import { useState } from 'react'
import { useNavigate } from 'react-router-dom'
import { useDispatch, useSelector } from 'react-redux'

// antd
import {
    Layout,
    Card,
    Row,
    Col,
    Typography,
    Avatar,
    Popover,
    Space,
    Image,
    Divider,
    message,
} from 'antd'
import { LogoutOutlined } from '@ant-design/icons'

// slices
import {
    isLoggedInLogin,
    loginState,
    signOut,
} from '../../../login/login.slice'

// components
import DeletePopUp from '../../../../components/deletePopUp/deletePopUp'

// constants
import {
    DOMAIN_LIST,
    SUPER_ADMIN,
    WORKSPACE_ADMIN,
} from '../../../../constants/roles'

// routes
import { PRIVATE_ROUTES, PUBLIC_ROUTES } from '../../../../routes'

// css
import styles from '../../../../layouts/layouts.module.css'

import { svgCompnyeLogoFull } from '../../../../assets/svg'

import '../index.css'

const { Header, Content } = Layout
const { Title, Text } = Typography

// Greeting logic
const getGreeting = () => {
    const hour = new Date().getHours()
    if (hour < 12) return 'Good morning'
    else if (hour < 17) return 'Good afternoon'
    else return 'Good evening'
}
const initialState = {
    openProfile: false,
    deleteModal: false,
    deleteButtonLoading: false,
    openDrawer: false,
}

const AppListView = () => {
    const navigate = useNavigate()
    const { userProfile, socketClient } = useSelector(loginState)
    const [state, setState] = useState(initialState)

    const handleOpenProfile = (newOpen) => {
        setState({ ...state, openProfile: newOpen })
    }
    const dispatch = useDispatch()

    // LOGOUT
    const logOut = async () => {
        const result = await dispatch(signOut())
        const data = result?.payload?.data
        if (data) {
            const { success, message: logOutMessage } = data
            if (success) {
                localStorage.removeItem('token')
                sessionStorage.removeItem('token')
                if (Object.keys(socketClient).length !== 0) {
                    socketClient.disconnect()
                }
                setState({ ...state, deleteButtonLoading: false })
                message.success(logOutMessage)
                const result = await dispatch(isLoggedInLogin())

                const data = result?.payload?.data
                if (data) {
                    const { success } = data
                    if (!success) {
                        navigate(PUBLIC_ROUTES.login)
                        window.localStorage.clear()
                    }
                }
            } else {
                setState({ ...state, deleteButtonLoading: false })

                message.error('Something went wrong, try again later.')
            }
        }
    }

    // const handleAppClick = (app) => {
    //     const domain = userProfile?.currentWorkSpace?.domain
    //     const role = userProfile?.role?.roleName
    //     const activeProject = userProfile?.activeProject

    //     if (app.name.toLowerCase() === 'workspace') {
    //         let finalRoute = ''

    //         if (role === SUPER_ADMIN && DOMAIN_LIST.includes(domain)) {
    //             finalRoute = PRIVATE_ROUTES.workSpace
    //         } else if (activeProject === null && DOMAIN_LIST.includes(domain)) {
    //             finalRoute = PRIVATE_ROUTES.userWorkSpace
    //         } else if (
    //             activeProject === null &&
    //             !DOMAIN_LIST.includes(domain)
    //         ) {
    //             finalRoute = PRIVATE_ROUTES.projects.root
    //         } else {
    //             finalRoute = PRIVATE_ROUTES.overview
    //         }

    //         // Open internal route in a new tab
    //         const url = `${window.location.origin}${finalRoute}`
    //         window.open(url, '_blank')
    //     } else if (app.link) {
    //         // External apps
    //         window.open(app.link, '_blank')
    //     }
    // }

    // const handleAppClick = (app) => {
    //     const domain = userProfile?.currentWorkSpace?.domain
    //     const role = userProfile?.role?.roleName
    //     const activeProject = userProfile?.activeProject

    //     if (app.name.toLowerCase() === 'pms') {
    //         if (
    //             role === SUPER_ADMIN &&
    //             DOMAIN_LIST.includes(domain)
    //         ) {
    //             navigate(PRIVATE_ROUTES.workSpace)
    //         } else if (
    //             activeProject === null &&
    //             DOMAIN_LIST.includes(domain)
    //         ) {
    //             navigate(PRIVATE_ROUTES.userWorkSpace)
    //         } else if (
    //             activeProject === null &&
    //             !DOMAIN_LIST.includes(domain)
    //         ) {
    //             navigate(PRIVATE_ROUTES.projects.root)
    //         } else {
    //             navigate(PRIVATE_ROUTES.overview)
    //         }
    //     } else if (app.link) {
    //         window.open(app.link, '_blank')
    //     }
    // }
    const handleAppClick = (app) => {
        const domain = userProfile?.currentWorkSpace?.domain
        const role = userProfile?.role?.roleName
        const activeProject = userProfile?.activeProject

        if (app?.name?.toLowerCase() === 'home') {
            let finalRoute = ''

            if (role === SUPER_ADMIN && DOMAIN_LIST.includes(domain)) {
                finalRoute = PRIVATE_ROUTES.jobs
            } else if (activeProject === null && DOMAIN_LIST.includes(domain)) {
                finalRoute = PRIVATE_ROUTES.userWorkSpace
            } else if (
                activeProject === null &&
                !DOMAIN_LIST.includes(domain)
            ) {
                finalRoute = PRIVATE_ROUTES.projects.root
            } else {
                finalRoute = PRIVATE_ROUTES.overview
            }

            navigate(finalRoute)
        } else if (app?.domain) {
            const url = app.domain.startsWith('http')
                ? app.domain
                : `https://${app.domain}`
            window.open(url, '_blank')
        }
    }

    // const homeApp = {
    //     name: 'Home',
    //     imageUrl: '/logo192.png',
    //     imageUrl:
    //         'https://pms-bucket123.s3.amazonaws.com/Home_dark_1754048350.svg',
    //     domain: 'http://localhost:3000/',
    //     order: 0,
    // }

    const apps = [
        // homeApp,
        ...(userProfile?.appPermission || []),
    ]
        .filter((app) => app?.isAllowed !== false)
        .sort((a, b) => a?.order - b?.order)

    return (
        <Layout style={{ minHeight: '100vh' }}>
            {/* Header */}
            <Header
                style={{
                    background: '#fff',
                    padding: '0 25px 0px 30px',
                    display: 'flex',
                    justifyContent: 'space-between',
                    alignItems: 'center',
                }}
            >
                <img src={svgCompnyeLogoFull} alt="Company Logo" width={200} />
                <Popover
                    overlayInnerStyle={{
                        padding: 0,
                    }}
                    getPopupContainer={(trigger) => trigger.parentNode}
                    open={state?.openProfile}
                    onOpenChange={handleOpenProfile}
                    content={
                        <>
                            <Row
                                style={{
                                    padding: 12,
                                    cursor: 'pointer',
                                }}
                                onClick={() => {
                                    if (
                                        userProfile?.role?.roleName !==
                                            SUPER_ADMIN &&
                                        userProfile?.role?.roleName !==
                                            WORKSPACE_ADMIN &&
                                        DOMAIN_LIST.includes(
                                            userProfile?.currentWorkSpace
                                                ?.domain
                                        )
                                    ) {
                                        setState({
                                            ...state,
                                            openProfile: false,
                                        })
                                        navigate(PRIVATE_ROUTES.profile)
                                    }
                                }}
                            >
                                <Space size={'middle'}>
                                    <Col>
                                        {userProfile?.profilePicture ? (
                                            <>
                                                <Image
                                                    src={
                                                        userProfile?.profilePicture
                                                    }
                                                    height={40}
                                                    width={40}
                                                    rootClassName="headerImage"
                                                    style={{
                                                        borderRadius: '50%',

                                                        cursor: 'pointer',
                                                    }}
                                                    preview={false}
                                                />
                                            </>
                                        ) : (
                                            <Avatar
                                                size={'large'}
                                                style={{
                                                    backgroundColor:
                                                        'rgb(0 10 129 / 25%)',
                                                }}
                                            >
                                                {userProfile?.name
                                                    ? `${userProfile?.name[0].toUpperCase()}${
                                                          userProfile?.name.split(
                                                              ' '
                                                          )[1] !== undefined
                                                              ? userProfile?.name
                                                                    .split(
                                                                        ' '
                                                                    )[1][0]
                                                                    .toUpperCase()
                                                              : ''
                                                      }`
                                                    : ''}
                                            </Avatar>
                                        )}
                                    </Col>
                                    <Col>
                                        <Row>
                                            <Text>{userProfile?.name}</Text>
                                            &nbsp;
                                            <Text
                                                style={{
                                                    textTransform: 'capitalize',
                                                    fontWeight: 500,
                                                }}
                                            >
                                                ({userProfile?.role?.roleName})
                                            </Text>
                                        </Row>
                                        <Text
                                            style={{
                                                fontSize: '12px',
                                            }}
                                        >
                                            {userProfile?.email}
                                        </Text>
                                    </Col>
                                </Space>
                            </Row>
                            <Divider
                                style={{
                                    margin: 0,
                                }}
                            />
                            <div
                                style={{
                                    padding: '5px',
                                }}
                                onClick={() => {
                                    setState({
                                        ...state,
                                        openProfile: false,
                                        deleteModal: true,
                                    })
                                }}
                            >
                                <div className={styles.logoutCard}>
                                    <Row
                                        align={'middle'}
                                        style={{
                                            gap: 10,
                                        }}
                                    >
                                        <LogoutOutlined
                                            style={{
                                                fontSize: '19px',
                                            }}
                                        />
                                        <Text
                                            style={{
                                                fontSize: '15px',
                                            }}
                                        >
                                            Log out
                                        </Text>
                                    </Row>
                                </div>
                            </div>
                        </>
                    }
                    trigger="click"
                    arrow={false}
                    placement="bottomLeft"
                >
                    {userProfile?.profilePicture ? (
                        <Image
                            src={userProfile?.profilePicture}
                            height={36}
                            className="headerImage"
                            width={36}
                            style={{
                                borderRadius: '50%',
                                verticalAlign: 'baseline !important',
                                cursor: 'pointer',
                            }}
                            preview={false}
                        />
                    ) : (
                        <Avatar
                            size={'large'}
                            style={{
                                cursor: 'pointer',
                                backgroundColor: 'rgb(0 10 129 / 25%)',
                            }}
                        >
                            {userProfile?.name[0].toUpperCase()}
                            {userProfile?.name.split(' ')[1] !== undefined &&
                                userProfile?.name
                                    .split(' ')[1][0]
                                    .toUpperCase()}
                        </Avatar>
                    )}
                </Popover>
            </Header>

            {/* Main Content */}
            <Content
                style={{
                    padding: '16px 0px',
                    maxWidth: '1200px',
                    margin: '0 auto',
                    width: '100%',
                }}
            >
                <div style={{ marginBottom: '30px', marginTop: '12px' }}>
                    <Title style={{ fontSize: '30px', fontWeight: '700' }}>
                        {getGreeting()}, {userProfile?.name}
                    </Title>
                </div>
                <div style={{ marginBottom: 16 }}>
                    <Text strong style={{ fontSize: '17px' }}>
                        Which App Do you want to access?
                    </Text>
                </div>
                <Row gutter={[16, 16]} style={{ marginTop: '10px' }}>
                    {apps.map((app, index) => (
                        <Col xs={12} sm={8} md={6} lg={4} key={index}>
                            <Card
                                hoverable
                                className="custom-hover-card"
                                style={{
                                    textAlign: 'center',
                                    height: 140,
                                    width: '100%',
                                    display: 'flex',
                                    alignItems: 'center',
                                    justifyContent: 'center',
                                    position: 'relative',
                                }}
                                bodyStyle={{ padding: 0 }}
                                onClick={() => handleAppClick(app)}
                            >
                                {/* Arrow corner */}
                                <div
                                    className="go-corner"
                                    onClick={() => handleAppClick(app)}
                                >
                                    <div className="go-corner">
                                        <div className="go-arrow">→</div>
                                    </div>
                                </div>

                                <div
                                    style={{
                                        width: 120,
                                        height: 80,
                                        display: 'flex',
                                        justifyContent: 'center',
                                        alignItems: 'center',
                                        margin: '0 auto',
                                    }}
                                >
                                    <img
                                        src={app?.imageUrl}
                                        alt={app?.name}
                                        style={{
                                            maxHeight:
                                                app?.name === 'StoryX'
                                                    ? '20px'
                                                    : '15px',
                                            maxWidth: '100%',
                                            objectFit: 'contain',
                                        }}
                                    />
                                </div>
                            </Card>
                        </Col>
                    ))}
                </Row>
            </Content>
            <DeletePopUp
                previewDelete={state?.deleteModal}
                onDelete={() => {
                    setState({ ...state, deleteButtonLoading: true })
                    logOut()
                }}
                loadingButton={state?.deleteButtonLoading}
                onCancel={() => {
                    setState({
                        ...state,
                        deleteButtonLoading: false,
                        deleteModal: false,
                    })
                }}
                modalTitle="Log Out"
                keyModal="logout"
            />
        </Layout>
    )
}

export default AppListView
